import { useEffect } from 'react';
import { useSession } from '@nextgen-web-framework/all';
import { SearchCard, getFulfillmentType } from '@commerce-product-webcomponents/ui';
import { getPrice, Product, getItemWithInventory } from '@commerce-search-webcomponents/sdk';
import { ProductData, productDataTransformer } from '@commerce-product-webcomponents/sdk';
import type { AddToCartOrGroupCartProps } from '@commerce-cart-webcomponents/ui-composite';
import ProductCardLoaders from '../ProductCardLoaders/ProductCardLoaders';
import { INVENTORY_SET } from '../types/enums';
import { ProductCardItemsProps } from './types/propsTypes';
import styles from './ProductCardItems.module.scss';

const ProductCardItems = ({
  products,
  setLastProductCard,
  loading,
  limit,
  showDesktopFacets,
}: ProductCardItemsProps) => {
  const sessionDetails = useSession();

  useEffect(() => {
    const lastCard = document.querySelector<HTMLLIElement>('.card-list-item:last-child');
    if (lastCard) {
      setLastProductCard(lastCard);
    }
  }, [products]);

  const getInventoryDetailWithItem = (item: Product) => {
    const fulFillmentId = getFulfillmentType() as string;
    const viewName = INVENTORY_SET[fulFillmentId as keyof typeof INVENTORY_SET];
    return getItemWithInventory(item, fulFillmentId, viewName);
  };

  return (
    <ul className={`${styles['product-cards-container']} ${showDesktopFacets && styles['desktop-facets-visible']}`}>
      {products?.map((item: Product) => {
        const newItem = getInventoryDetailWithItem(item);
        const productData = {
          ...productDataTransformer(newItem as ProductData),
          productPrice: getPrice(item, sessionDetails) as number,
        };
        const { flags } = item;
        return (
          <li key={productData.productId} className={`${styles['card-item']} card-list-item`}>
            <SearchCard
              disabled={flags.restrictFromAddToCart}
              entryObj={{ ...productData, link: productData.mainLink } as AddToCartOrGroupCartProps['entryObj']}
              productData={productData}
              showAddToWishlistComp
              isFlexibleWidthCard
            />
          </li>
        );
      })}
      {loading && <ProductCardLoaders limit={limit} />}
    </ul>
  );
};
export default ProductCardItems;
export type { ProductCardItemsProps };
